export const BYTES_IN_KILOYTE = 1024;
export const BYTES_IN_MEGABYTE = BYTES_IN_KILOYTE * BYTES_IN_KILOYTE;
export const BYTES_IN_GIGABYTE = BYTES_IN_MEGABYTE * BYTES_IN_KILOYTE;
export const BYTES_IN_TERABYTE = BYTES_IN_GIGABYTE * BYTES_IN_KILOYTE;

export function formatFileSizeRounded(bytes: number): string {
  if (bytes < BYTES_IN_KILOYTE) {
    return `${bytes} B`;
  }

  if (bytes < BYTES_IN_MEGABYTE) {
    return `${Math.round(bytes / BYTES_IN_KILOYTE)} KB`;
  }

  if (bytes < BYTES_IN_GIGABYTE) {
    return `${Math.round(bytes / BYTES_IN_MEGABYTE)} MB`;
  }

  if (bytes < BYTES_IN_TERABYTE) {
    return `${Math.round(bytes / BYTES_IN_GIGABYTE)} GB`;
  }

  return `${Math.round(bytes / BYTES_IN_TERABYTE)} TB`;
}

export function formatFileSize(bytes: number, decimals = 1): string {
  if (bytes < BYTES_IN_KILOYTE) {
    return `${bytes} B`;
  }

  if (bytes < BYTES_IN_MEGABYTE) {
    return `${(bytes / BYTES_IN_KILOYTE).toFixed(decimals)} KB`;
  }

  if (bytes < BYTES_IN_GIGABYTE) {
    return `${(bytes / BYTES_IN_MEGABYTE).toFixed(decimals)} MB`;
  }

  if (bytes < BYTES_IN_TERABYTE) {
    return `${(bytes / BYTES_IN_GIGABYTE).toFixed(decimals)} GB`;
  }

  return `${(bytes / BYTES_IN_TERABYTE).toFixed(decimals)} TB`;
}
